<ion-split-pane when="xs" contentId="main-content" *ngIf="shouldShowMenu">
    <ion-menu contentId="main-content" class="no-border" [disabled]="menuDisabled">
        <ion-header class="ion-no-border">
            <ion-title class="nasalization-font logo ion-no-padding" (click)="navigateHome()">
                <ng-container *ngIf="organizationImageUrl === undefined">
                    <!-- Loading spinner while logo is being loaded -->
                    <ion-spinner name="crescent" class="spinner-md"></ion-spinner>
                </ng-container>
                <ng-container *ngIf="organizationImageUrl !== undefined">
                    <ng-container *ngIf="organizationImageUrl; else defaultLogo">
                        <img [src]="organizationImageUrl" alt="Organization Logo" class="organization-logo" />
                    </ng-container>
                    <ng-template #defaultLogo>
                        {{userIsOnMobile ? 'A⁹' : 'AVALON⁹'}}
                    </ng-template>
                </ng-container>
            </ion-title>
            <div *ngIf="!userIsOnMobile">
                <ion-grid>
                    <ion-row>
                        <ion-col size="4">
                            <ion-avatar>
                                <img alt="Silhouette of a person's head"
                                    [src]="authService.getCurrentUserPhotoURL() || 'assets/images/placeholder.jpg'" />
                            </ion-avatar>
                        </ion-col>
                        <ion-col size="8" class="welcome-section">
                            <ion-row class="welcome-text">
                                Bienvenido,
                            </ion-row>
                            <ion-row>
                                {{userFullName}}
                            </ion-row>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </div>
        </ion-header>
        <ion-content>
            <!-- Organization selector for superadmins (desktop) -->
            <div *ngIf="userIsSuperadmin && !userIsOnMobile" class="organization-selector-menu">
                <div class="organization-selector-label">Visualizar organización</div>
                <ion-select [value]="selectedOrganization" 
                            interface="popover" 
                            (ionChange)="onOrganizationChange($event)" 
                            class="organization-selector"
                            placeholder="Seleccionar"
                            fill="solid"
                            mode="md">
                    <ion-select-option [value]="org.name"
                        *ngFor="let org of organizations$ | async">{{org.name}}</ion-select-option>
                </ion-select>
            </div>

            <div class="general-list-header" *ngIf="!userIsOnMobile">General</div>
            <ion-list class="ion-no-padding menu-list">
                <ion-item [routerLink]="card.url" lines="none" [ngClass]="userIsOnMobile ? 'ion-no-padding' : ''"
                    *ngFor="let card of generalAccessibleCards">
                    <ion-icon [name]="card.icon"></ion-icon>
                    <ion-label>{{card.title}}</ion-label>
                    <ion-badge *ngIf="card.badge != '0'">{{card.badge}}</ion-badge>
                </ion-item>
            </ion-list>

            <div class="administrative-list-header"
                *ngIf="!userIsOnMobile && administrativeAccessibleCards?.length">Administración</div>
            <ion-list class="ion-no-padding menu-list">
                <ion-item [routerLink]="card.url" lines="none" [ngClass]="userIsOnMobile ? 'ion-no-padding' : ''"
                    *ngFor="let card of administrativeAccessibleCards">
                    <ion-icon [name]="card.icon"></ion-icon>
                    <ion-label>{{card.title}}</ion-label>
                    <ion-badge *ngIf="card.badge != '0'">{{card.badge}}</ion-badge>
                </ion-item>
            </ion-list>

        </ion-content>
        <ion-footer class="ion-no-border">
            <div class="version-footer" (click)="navigateToChangelog()">
                v{{appVersion}}
            </div>
        </ion-footer>
    </ion-menu>
    <div id="main-content">
        <ion-header>
            <ion-toolbar class="tooolbar">
                <ion-buttons slot="start">
                    <ion-menu-button autoHide="false" (click)="toggleMenu()"></ion-menu-button>
                </ion-buttons>
                <ion-buttons slot="end">
                    <!-- <ion-button (click)="openMessagesPopover($event)">
                        <ion-icon name="mail-outline"></ion-icon>
                    </ion-button> -->
                    <ion-button (click)="openProfilePopover($event)">
                        <ion-avatar slot="start" class="toolbar-avatar">
                            <img alt="Silhouette of a person's head"
                                [src]="authService.getCurrentUserPhotoURL() || 'assets/images/placeholder.jpg'" />
                        </ion-avatar>
                        <ion-label>{{userFullName}}</ion-label>
                        <ion-badge *ngIf="userIsSuperadmin" class="toolbar-admin-badge">
                            {{ userIsOnMobile ? 'ADM' : 'Administrador' }}
                        </ion-badge>
                    </ion-button>
                </ion-buttons>
            </ion-toolbar>
            <ion-toolbar *ngIf="userIsSuperadmin && userIsOnMobile" class="organization-toolbar">
                <div class="organization-selector-mobile">
                    <div class="organization-selector-label">Visualizar organización</div>
                    <ion-select [value]="selectedOrganization" 
                                interface="popover" 
                                (ionChange)="onOrganizationChange($event)" 
                                class="organization-selector organization-selector-mobile-select"
                                placeholder="Seleccionar"
                                fill="solid"
                                mode="md">
                        <ion-select-option [value]="org.name"
                            *ngFor="let org of organizations$ | async">{{org.name}}</ion-select-option>
                    </ion-select>
                </div>
            </ion-toolbar>
        </ion-header>
        <ion-router-outlet></ion-router-outlet>
    </div>
</ion-split-pane>

<div *ngIf="!shouldShowMenu">
    <ion-router-outlet id="main-content">
    </ion-router-outlet>
</div>